import React, { Component } from 'react'
import styled from 'styled-components'
import { pxToRem } from '../../utils'
import FirstPageIcon from '../../../src/assets/icons/first-page.svg'
import LastPageIcon from '../../../src/assets/icons/last-page.svg'
import NextPageIcon from '../../../src/assets/icons/next-page.svg'
import PreviousPageIcon from '../../../src/assets/icons/previous-page.svg'

const Pagination = styled.tfoot`
  background: '#fff';
  border-radius: 0 0 ${pxToRem('10px')} ${pxToRem('10px')};
`

const Content = styled.div`
  display: flex;
  justify-content: flex-end;
  p {
    font-size: ${pxToRem(16)};
    margin-right: ${pxToRem(5)};
  }
`

const SelectRowsPerPage = styled.select`
  margin: auto 0px;
`

const Divisor = styled.div`
  margin: 0px 10px;
`

const FirstButton = styled.button`
  border: none; 
  height: 26px;
  margin: auto 5px;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`

const NextButton = styled.button`
  border: none;
  height: 26px;
  margin: auto 5px;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`

const PreviousButton = styled.button`
  border: none;
  height: 26px;
  margin: auto 5px;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`

const LastButton = styled.button`
  border: none;
  height: 26px;
  margin: auto 5px;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`

const WithoutPagination = styled.div`
  background: #fff;
  color: #5b666d;
  min-height: ${pxToRem(26)};
  div {
    text-align: center;
    margin: 5px;
  }
  strong {
    font-size: ${pxToRem(16)};
    text-align: center;
  }
`

class TablePagination extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rowsPerPage: this.props.rowsPerPage,
      currentPage: this.props.currentPage,
      totalPages: this.props.totalPages,
      buttonNextDisable: false,
      buttonPreviousDisable: true,
      buttonFirstDisable: true,
      buttonLastDisable: false
    }
  }

  currentPageEqualsTotalPages() {
    return this.props.currentPage === this.props.totalPages
  }

  currentPageEqualsOne() {
    return this.props.currentPage === 1
  }

  enableAll() {
    this.setState({
      buttonLastDisable: false,
      buttonNextDisable: false,
      buttonPreviousDisable: false,
      buttonFirstDisable: false
    })
  }

  handlePreviousButton = async event => {
    const { currentPage, rowsPerPage } = this.props
    const newPage = currentPage - 1
    if (newPage > 0) {
      return this.props.onChangePage(newPage, rowsPerPage)
    } 
    return this.props.onChangePage(1, rowsPerPage)
  }

  handleNextButton = async event => {
    const { currentPage, totalPages, rowsPerPage } = this.props
    
    const newPage = currentPage + 1
    
    if (newPage <= totalPages) {
      return this.props.onChangePage(newPage, rowsPerPage)
    }
    return this.props.onChangePage(1, rowsPerPage)
  }

  render() {
    const {
      rowsPerPageOptions,
      labelRowsPerPage = 'Linhas por página: ',
      labelPages = 'Página: ',
      colSpan,
      rowsPerPage,
      currentPage, 
      totalPages
    } = this.props
    
    return (
      currentPage && totalPages ? (
      <Pagination colSpan={colSpan}>
        <tr>
          <td colspan={5}>
            <Content>
              <p>{labelRowsPerPage}</p>
              {rowsPerPageOptions.length > 1 && (
                <SelectRowsPerPage
                  value={rowsPerPage}
                  onChange={(event, currentPage) => this.props.onChangeRowsPerPage(parseInt(event.currentTarget.value), currentPage)}>
                  {rowsPerPageOptions.map(rowsPerPageOption => {
                  return <option value={rowsPerPageOption.value}>{rowsPerPageOption.label}</option>
                  })}
                </SelectRowsPerPage>
              )}
              <Divisor />
              <FirstButton
                onClick={event => {
                  this.props.onChangePage(1, rowsPerPage)
                }}
                disabled={this.currentPageEqualsOne()}>
                  <img src={FirstPageIcon} alt=""/>
                </FirstButton>
              <PreviousButton
                onClick={event => {
                  this.handlePreviousButton()
                }}
                disabled={this.currentPageEqualsOne()}
              >
                <img src={PreviousPageIcon} alt=""/>
              </PreviousButton>
              <p>
                {labelPages} {currentPage} de {totalPages}
              </p>
              <NextButton
                onClick={event => {
                  this.handleNextButton()
                }}
                disabled={this.currentPageEqualsTotalPages()}
                >
                <img src={NextPageIcon} alt=""/>
              </NextButton>
              <LastButton
                onClick={event => {
                  this.props.onChangePage(totalPages, rowsPerPage)
                }}
                disabled={this.currentPageEqualsTotalPages()}
              >
                <img src={LastPageIcon} alt= "" />
              </LastButton>
            </Content>
          </td>
        </tr>
      </Pagination>
      ) : (
        null
      )
    )
  }
}

export default TablePagination



// WEBPACK FOOTER //
// ./src/components/Table/TablePagination.js